/* Transcription interactive synchronisée — BEM gas-video-transcript. */

.gas-video-transcript {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-s, 5px);
    max-height: 420px;
    border: 1px solid var(--gas-color-border, #dadce0);
    border-radius: var(--gas-radius-m, 8px);
    background: var(--gas-color-surface, #fff);
    overflow: hidden;
}

/* Variante « nue » : utilisée quand le drawer est déjà encapsulé dans un
   GasSection (carte + header repliable) — on évite le double cadre. */
.gas-video-transcript--bare {
    border: none;
    border-radius: 0;
    background: transparent;
    max-height: none;
    gap: var(--gas-space-s, 5px);
}

.gas-video-transcript--bare .gas-video-transcript__list {
    max-height: 320px;
}

.gas-video-transcript__title {
    margin: 0;
    padding: var(--gas-space-s, 6.25px) var(--gas-space-m, 10px);
    font-size: var(--gas-text-s, 8.75px);
    font-weight: 600;
    border-bottom: 1px solid var(--gas-color-border, #dadce0);
    background: var(--gas-color-surface-alt, #f8f9fa);
}

.gas-video-transcript__list {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    /* Scroll INTERNE borné : l'auto-scroll de la ligne active reste dans le
       drawer et ne fait jamais remonter la fenêtre du navigateur. */
    max-height: 340px;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding: var(--gas-space-xs, 2.5px);
}

.gas-video-transcript__cue {
    text-align: left;
    border: none;
    background: transparent;
    color: var(--gas-color-text-muted, #5f6368);
    padding: var(--gas-space-xs, 3.75px) var(--gas-space-s, 6.25px);
    border-radius: var(--gas-radius-s, 4px);
    cursor: pointer;
    font-size: var(--gas-text-s, 9.375px);
    line-height: 1.5;
    transition: background 120ms ease, color 120ms ease;
}

.gas-video-transcript__cue:hover {
    background: var(--gas-color-surface-alt, #f1f3f4);
}

.gas-video-transcript__cue--active {
    background: var(--gas-color-primary-surface, #e8f0fe);
    color: var(--gas-color-text, #1a1a1a);
    font-weight: 500;
}

.gas-video-transcript__word {
    transition: color 80ms ease;
}

.gas-video-transcript__word--active {
    color: var(--gas-color-primary, #1a73e8);
    font-weight: 700;
}

/* Mot correspondant à la recherche (révélé dans le résultat courant). */
.gas-video-transcript__word--hit {
    background: var(--gas-color-warning-surface, #fef7e0);
    color: var(--gas-color-text, #1a1a1a);
    border-radius: var(--gas-radius-s, 3px);
    box-shadow: 0 0 0 1px var(--gas-color-warning, #f59e0b) inset;
}

/* Recherche dans la vidéo. */
.gas-video-transcript__search {
    display: flex;
    align-items: center;
    gap: var(--gas-space-xs, 5px);
    margin-bottom: var(--gas-space-s, 5px);
}

.gas-video-transcript__search-input {
    flex: 1;
    padding: var(--gas-space-xs, 3.75px) var(--gas-space-s, 6.25px);
    border: 1px solid var(--gas-color-border, #dadce0);
    border-radius: var(--gas-radius-s, 6px);
    background: var(--gas-color-surface, #fff);
    color: var(--gas-color-text, #1a1a1a);
    font-size: var(--gas-text-s, 8.75px);
}

.gas-video-transcript__search-nav {
    display: inline-flex;
    align-items: center;
    gap: var(--gas-space-xs, 2.5px);
}

.gas-video-transcript__search-count {
    font-size: var(--gas-text-s, 8.125px);
    color: var(--gas-color-text-muted, #5f6368);
    font-variant-numeric: tabular-nums;
    min-width: 25px;
    text-align: center;
}

.gas-video-transcript__search-btn {
    width: 17.5px;
    height: 17.5px;
    border: 1px solid var(--gas-color-border, #dadce0);
    border-radius: var(--gas-radius-s, 6px);
    background: var(--gas-color-surface, #fff);
    color: var(--gas-color-text, #1a1a1a);
    cursor: pointer;
    line-height: 1;
}

.gas-video-transcript__search-btn:disabled {
    opacity: 0.4;
    cursor: default;
}

.gas-video-transcript__cue--match {
    background: var(--gas-color-warning-surface, #fef7e0);
}

.gas-video-transcript__cue--match-current {
    outline: 2px solid var(--gas-color-warning, #f59e0b);
    outline-offset: -2px;
}
